import React from "react";
import { IAutomobileDriverInformation } from "../../../../../../../redux/automobileDriver/automobileDriver.types";
import { RightPanel } from "../../../../../../../components/RightPanel";
import { AutomobileDriverInformation } from "./AutomobileDriverInformation";

interface IAutomobileDriverRightPanelProps {
  open: boolean;
  customerId?: number;
  customerPolicyId?: number;
  driverNumber?: number;
  onSaveSuccess: (driver: IAutomobileDriverInformation) => void;
  staticStatusValue?: string;
  created_from?: string;
  readonly?: boolean;
  onClose: () => void;
  initialData?: IAutomobileDriverInformation;
  disableApiCalls?: boolean;
}

export const AutomobileDriverRightPanel: React.FC<
  IAutomobileDriverRightPanelProps
> = (props) => {
  const {
    customerId,
    customerPolicyId,
    driverNumber,
    onClose,
    onSaveSuccess,
    readonly,
    staticStatusValue,
    created_from,
    initialData,
    disableApiCalls,
  } = props;

  return (
    <>
      <RightPanel
        heading="Driver Information"
        //subHeading="Add notes or comments"
        open={true}
        onClose={onClose}
        width="90%"
      >
        <AutomobileDriverInformation
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          driverNumber={driverNumber}
          onSaveSuccess={onSaveSuccess}
          readOnly={readonly}
          fromRightPanel
          staticStatusValue={staticStatusValue}
          created_from={created_from}
          initialData={initialData}
          disableApiCalls={disableApiCalls}
        />
      </RightPanel>
    </>
  );
};
